<div class="ng-container">
    <div class="ng-content">
        <div class="ng-class-and-rating">
            <app-hotel-stars [value]="tour.stars || tour.hotelClass"></app-hotel-stars>
            <app-hotel-rating *ngIf="tour.rating"
                              [rating]="tour.rating"></app-hotel-rating>
        </div>

        <p class="ng-hotel-name showHotelInfo"
           data-target-tab="tabPhoto"
           data-target-scroll="gallery-with-previews">
            {{ hotelName }}
            <span *ngIf="tour.isCombined">({{ messages.combiTour }})</span>
        </p>
        <p class="ng-hotel-region">{{ tour.country }}, {{ tour.region }}</p>

        <p *ngIf="tour.departCity; else withoutDepart"
           class="ng-depart-info">
            {{ messages.departure | template: departureMapping(tour.dateFrom, tour.departCityFrom) }}
        </p>

        <p class="ng-nights">
            {{ messages.nightsCount | template: nightsMapping(tour.nights + 1) }}
        </p>

        <div class="ng-footer">
            <div class="ng-description showHotelInfo"
                 data-target-tab="tabInfo">{{ messages.hotelDescription }}</div>
        </div>
    </div>
</div>

<ng-template #withoutDepart>
    <div class="ng-depart-info">
        {{ messages.checkIn }} {{ checkInDate(tour.dateFrom) }}
    </div>
</ng-template>
